import { get } from 'lodash';
import UserModel from '../../../../UserModel';
import { isOktaEnalbed } from '../../oktaLogin/utils';

//to remove in 32.x.x
export const hasAnyPermissions = (permissions) => UserModel.getCurrentUser().hasAnyPermissions(permissions);

const generatePassword = () => {
    const lower = 'abcdefghijklmnopqrstuvwxyz';
    const upper = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';
    const digits = '0123456789';
    const special = '!@#$%^&*()_+-=[]{}|;:,.<>?';

    const all = lower + upper + digits + special;

    // Ensure at least one of each required character type
    let password = [
        lower[Math.floor(Math.random() * lower.length)],
        upper[Math.floor(Math.random() * upper.length)],
        digits[Math.floor(Math.random() * digits.length)],
        special[Math.floor(Math.random() * special.length)],
    ];

    // Fill the rest of the 8 characters
    for (let i = password.length; i < 8; i++) {
        password.push(all[Math.floor(Math.random() * all.length)]);
    }

    // Shuffle the password array
    password = password.sort(() => 0.5 - Math.random());

    return password.join('');
};

export const isSkunexusUser = () => {
    if (!isOktaEnalbed()) {
        return true;
    }

    const email = get(UserModel.getCurrentUser().getExtra(), 'email', '');

    return email.endsWith('@skunexus.com');
};

export const removeCurrentPasswordFormFromFormFields = (data) => {
    if (!isOktaEnalbed()) {
        return data;
    }

    return data.filter(({ name }) => name !== 'current_user_password');
};

export const removeCurrentPasswordFormFromFormSections = (data) => {
    if (!isOktaEnalbed()) {
        return data;
    }

    const { currentUserPassword: iCUP, ...newFields } = data;

    return {
        ...newFields,
        password: (newFields?.password || []).map((field) => ({ field, type: 'hidden' })),
    };
};

export const removeCurrentPassowrdFromFormProps = (data) => {
    if (!isOktaEnalbed()) {
        return data;
    }

    const { current_user_password: iCUP, ...newInitialValues } = data.initialValues;
    const {
        current_user_password: vCUP,
        new_password: vNP,
        confirm_password: vCP,
        ...newValidationSchema
    } = data.validationSchema;

    const password = generatePassword();
    return {
        ...data,
        initialValues: {
            ...newInitialValues,
            new_password: password,
            confirm_password: password,
        },
        validationSchema: newValidationSchema,
    };
};
